module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#c4k",
      "id": "c04k"
    }
  }, [_vm._v("Image Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/flo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("The following images are pages from an 18"), _c('sup', [_vm._v("th")]), _vm._v(" century illuminated Haggadah that illustrates events in the life of Moses from the biblical book of Exodus, one of the original Five Books of Moses that began as the Torah."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("A Haggadah is a collection of Jewish prayers and readings written to accompany the Passover "), _c('i', [_vm._v("seder")]), _vm._v(", a ritual meal eaten on the eve of the Passover festival. The literal meaning of the Hebrew word Haggadah is a “narration” or “telling.” It refers to a command in Exodus, requiring Jews to “tell your son on that day: it is because of that which the Lord did for me when I came forth out of Egypt.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('span', [_vm._v("Hamburg Haggadah, 1731; Created by Ya’akov ben Yehuda Leyb, Sofer (Scribe); Black and gold ink and gray wash on vellum; 31 cm; Courtesy of The New York Public Library. "), _c('a', {
    attrs: {
      "href": "http://www.nypl.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nypl.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('span', [_vm._v("Pharaoh’s daughter went down to the Nile to bathe.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/img2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('span', [_vm._v("Hamburg Haggadah, 1731; Created by Ya’akov ben Yehuda Leyb, Sofer (Scribe); Black and gold ink and gray wash on vellum; 31 cm; Courtesy of The New York Public Library. "), _c('a', {
    attrs: {
      "href": "http://www.nypl.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nypl.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('span', [_vm._v("Egypt: Israelites build cities of Pithom and Ramses, right, and left, Moses slays an Egyptian.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/img3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('span', [_vm._v("Hamburg Haggadah, 1731; Created by Ya’akov ben Yehuda Leyb, Sofer (Scribe); Black and gold ink and gray wash on vellum; 31 cm; Courtesy of The New York Public Library. "), _c('a', {
    attrs: {
      "href": "http://www.nypl.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nypl.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('span', [_vm._v("They said to Pharaoh, “Thus says the Lord: Let my people go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/img4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('span', [_vm._v("Hamburg Haggadah, 1731; Created by Ya’akov ben Yehuda Leyb, Sofer (Scribe); Black and gold ink and gray wash on vellum; 31 cm; Courtesy of The New York Public Library. "), _c('a', {
    attrs: {
      "href": "http://www.nypl.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nypl.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('span', [_vm._v("And the Lord drowned Egypt while Israel walked on dry land in the middle of the sea.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/img5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('span', [_vm._v("Hamburg Haggadah, 1731; Created by Ya’akov ben Yehuda Leyb, Sofer (Scribe); Black and gold ink and gray wash on vellum; 31 cm; Courtesy of The New York Public Library. "), _c('a', {
    attrs: {
      "href": "http://www.nypl.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nypl.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('span', [_vm._v("Moses would speak and God would respond aloud; and the people said, “All that the Lord has decreed, we undertake to do.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01535576","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/image.vue
// module id = 78
// module chunks = 0